import React, { Component } from "react"
import PropTypes from "prop-types"
import { find, pull, indexOf, uniqueId, concat } from "lodash"
import SelectSearch from "../select-search"

import Tag from "../filter-tag"
import SearchFilterCheckbox from "../search-filter-checkbox"
import Button from "../button"

class SearchFilter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayFilter: false,
      filters: props.filters,
    }
  }

  toggleFilter = () => {
    const { displayFilter } = this.state

    this.setState({
      displayFilter: !displayFilter,
    })
  }

  searchSelectOption = field => {
    const { filters } = this.state
    const filter = find(filters, { field })

    return filter && filter.options.length > 0 ? filter.options[0] : ""
  }

  onSearchSelect = (field, option) => {
    const { onChange } = this.props
    const { filters } = this.state
    const filter = find(filters, { field })

    if (filter) {
      if (option === "") {
        pull(filters, filter)
      } else {
        filter.options = [option]
      }
    } else {
      if (option !== "") {
        filters.push({
          field: field,
          options: [option],
        })
      }
    }

    this.setState({ filters }, onChange(filters))
  }

  isFilterActive = value => {
    const { filters } = this.state
    const { field, option } = value
    const filter = find(filters, { field })

    return filter && !!~indexOf(filter.options, option)
  }

  clearFilters = (isMobile = false) => {
    const { onChange } = this.props

    this.setState({ filters: [] }, () => {
      onChange([])
      if (isMobile) {
        this.toggleFilter()
      }
    })
  }

  onFilterClick = value => {
    const { onChange } = this.props
    const { filters } = this.state
    const { field, option } = value
    const filter = find(filters, { field })

    if (filter) {
      if (!!~indexOf(filter.options, option)) {
        pull(filter.options, option)
        if (filter.options.length === 0) {
          pull(filters, filter)
        }
      } else {
        filter.options.push(option)
      }
    } else {
      filters.push({
        field,
        options: [option],
      })
    }

    this.setState({ filters }, onChange(filters))
  }

  buildFilterGroup = group => {
    if (group.style === "tags") {
      return (
        <div className="search-filter__options search-filter__options--tags">
          {group.options &&
            group.options.map(option => (
              <Tag
                key={uniqueId(option.key || option)}
                label={option.label || option}
                className="search-filter__tag"
                value={{
                  field: group.field,
                  option: option.key || option,
                }}
                onClick={this.onFilterClick}
                active={this.isFilterActive({
                  field: group.field,
                  option: option.key || option,
                })}
              />
            ))}
        </div>
      )
    }

    if (group.style === "search") {
      return (
        <div className="search-filter__options">
          <SelectSearch
            name={group.title}
            mode="input"
            options={concat(
              [
                {
                  name: "All",
                  value: "",
                },
              ],
              group.options
            )}
            placeholder={group.placeholder}
            onChange={option => {
              this.onSearchSelect(group.field, option.value)
            }}
            value={this.searchSelectOption(group.field)}
            autocomplete="off"
          />
        </div>
      )
    }

    return (
      <div className="search-filter__options">
        {group.options &&
          group.options.map(option => (
            <SearchFilterCheckbox
              key={uniqueId(option.key || option)}
              label={option.label || option}
              value={{
                field: group.field,
                option: option.key || option,
              }}
              onClick={this.onFilterClick}
              active={this.isFilterActive({
                field: group.field,
                option: option.key || option,
              })}
            />
          ))}
      </div>
    )
  }

  render() {
    const { displayFilter } = this.state
    const { filterGroups } = this.props

    return (
      <div className="search-filter">
        <Button
          className="search-filter__trigger btn--wide"
          iconName="Filter"
          text="Filter"
          onClick={this.toggleFilter}
        />
        <div
          className={`search-filter__content${
            displayFilter ? " search-filter__content--visible" : ""
          }`}
        >
          {filterGroups.map(fg => (
            <div key={uniqueId(fg.title)} className="search-filter__group">
              <p className="search-filter__heading">{fg.title}</p>
              {this.buildFilterGroup(fg)}
            </div>
          ))}

          <Button
            className="search-filter__clear search-filter__clear--lg btn--wide"
            text="Clear filters"
            iconName="X"
            onClick={this.clearFilters}
          />

          <footer className="search-filter__footer">
            <div className="grid grid--gutters-xsm">
              <div className="grid__col grid__col--1-2 grid__col--md-1-2">
                <Button
                  className="search-filter__clear btn--wide btn--reverse"
                  iconName="X"
                  text="Clear filters"
                  onClick={() => {
                    this.clearFilters(true)
                  }}
                />
              </div>
              <div className="grid__col grid__col--1-2 grid__col--md-1-2">
                <Button
                  className="search-filter__apply btn--wide btn--cta"
                  iconName="Search"
                  text="Apply filters"
                  onClick={this.toggleFilter}
                />
              </div>
            </div>
          </footer>
        </div>
      </div>
    )
  }
}

SearchFilter.defaultProps = {
  filterGroups: [],
  filters: [],
  onChange: () => {},
}

SearchFilter.propTypes = {
  filterGroups: PropTypes.arrayOf(
    PropTypes.shape({
      style: PropTypes.string,
      title: PropTypes.string,
      field: PropTypes.string,
      placeholder: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape({
            key: PropTypes.string,
            label: PropTypes.string,
          }),
        ])
      ),
    })
  ),
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  onChange: PropTypes.func,
}

export default SearchFilter
